declare global {
    interface Window {
        fbq?: any;
        _fbq?: any;
    }
}

const FB_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let isInitialized = false;

export const initMetaPixel = (): Promise<void> => {
    return new Promise((resolve) => {
        if (typeof window === "undefined") return resolve();

        // Already initialized
        if (isInitialized || window.fbq) {
            return resolve();
        }

        if (!FB_PIXEL_ID) {
            console.warn("[FB Pixel] Missing REACT_APP_META_APP_ID");
            return resolve();
        }

        (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];

            t = b.createElement(e);
            t.async = true;
            t.src = v;

            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );

        window.fbq("init", FB_PIXEL_ID);
        window.fbq("track", "PageView");

        isInitialized = true;

        resolve();
    });
};
